import Vue from 'vue'

Vue.component('enquiry-form', require('./components/EnquiryForm.vue').default);
Vue.component('newsletter-form', require('./components/NewsletterForm.vue').default);